// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14lHA","title":"Header_title__CF9Lc","left":"Header_left__2vdOd","clinicName":"Header_clinicName__2xorQ"};